<template>
    <settings-page :title="title" :description="description">
        <div style="border: 5px solid #eee; color: #ccc; padding: 100px 220px; display: inline-block; font-weight: 700; font-size: 24px;">
            COMING SOON
        </div>
    </settings-page>
</template>

<script>
import SettingsPage from '@/components/settings/shared/settings-page';

export default {
    name: 'settings-fonts',
    components: { SettingsPage },

    data() {
        return {
            title: 'Fonts',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        };
    },
};
</script>
